import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {HobbyItem, ICountriesItem, INationalityItem, IPaymentCategoriesItem, LanguagesItem, RegionItem} from '@/models';

import {create} from 'zustand';
import {handleApiCallInStore} from './utils';
import {http} from '@/utils';
import {persist} from 'zustand/middleware';

export interface ICommonStore {
  languages: LanguagesItem[];
  hobbies: HobbyItem[];
  nationalities: INationalityItem[];
  regions: RegionItem[];
  countries: ICountriesItem[];
  paymentCategories: IPaymentCategoriesItem[];
  getLanguages: () => void;
  getHobbies: (onSuccess?: (data: HobbyItem[]) => void) => void;
  getNationalities: () => void;
  getRegions: (onSuccess?: (regions: RegionItem[]) => void) => void;
  getCountries: () => void;
  getPaymentCategories: () => void;
}

export const useCommonStore = create(
  persist<ICommonStore>(
    set => ({
      nationalities: [],
      languages: [],
      hobbies: [],
      regions: [],
      countries: [],
      paymentCategories: [],
      getNationalities: async () => {
        handleApiCallInStore(LoadingKeys.getNationalities, async () => {
          const {data} = await http.get<{ items: INationalityItem[] }>(
            API_ENDPOINTS.nationalities
          );
          set(() => ({nationalities: data.items ?? []}));
        });
      },
      getLanguages: async () => {
        handleApiCallInStore(LoadingKeys.Languages, async () => {
          const {data} = await http.get<{ items: LanguagesItem[] }>(
            API_ENDPOINTS.languages
          );
          set(() => ({languages: data.items ?? []}));
        });
      },
      getHobbies: async onSuccess => {
        handleApiCallInStore(LoadingKeys.Hobbies, async () => {
          const {data} = await http.get<{ items: HobbyItem[] }>(
            API_ENDPOINTS.hobbies
          );
          if (onSuccess) {
            onSuccess(data.items);
          }
          set(() => ({hobbies: data.items ?? []}));
        });
      },
      getRegions: async onSuccess => {
        handleApiCallInStore(LoadingKeys.Regions, async () => {
          const {data} = await http.get<{ items: RegionItem[] }>(
            API_ENDPOINTS.regions
          );
          if (onSuccess) {
            onSuccess(data.items);
          }

          set(() => ({regions: data.items ?? []}));
        });
      },
      getCountries: async () => {
        handleApiCallInStore(LoadingKeys.Countries, async () => {
          const {data} = await http.get<{ items: ICountriesItem[] }>(
            API_ENDPOINTS.countries
          );
          set(() => ({countries: data.items ?? []}));
        });
      },
      getPaymentCategories: async () => {
        handleApiCallInStore(LoadingKeys.paymentCategories, async () => {
          const {data} = await http.get<{ items: IPaymentCategoriesItem[] }>(
            API_ENDPOINTS.paymentCategories
          );
          set(() => ({paymentCategories: data.items ?? []}));
        });
      },
    }),
    {
      name: 'common-storage',

    }
  )
);
